module.exports = "/_next/static/images/1-0f7c5369a31dc7e80db977d2b1a51835.jpg";